import React, { useEffect, useState } from "react";
import { SideBar } from "../../../../imports";
import Select from "react-select";


import { ObtenerPersonasCV } from "../../../../servicios/ServicioPersonaCV";
import { ObtenerInfoContacto } from "../../../../servicios/ServicioContacto";
import { ObtenerFormularios } from "../../../../servicios/ServicioFormulario";
import { ObtenerPreguntasPorFormulario } from "../../../../servicios/ServicioPreguntaFormulario";
import { CrearEvaluacion, GuardarRespuesta } from "../../../../servicios/ServicioEvaluacion";
import { ReportePersonasTrabajanRossmon, ReporteTotalPersonas, ReporteTotalPersonasPorEspecialidad } from '../../../../servicios/ServicioReportePersonas';

export default function EvaluacionCatalog() {
    const [formularios, setFormularios] = useState([]);
    const [preguntas, setPreguntas] = useState([]);
    const [evaluador, setEvaluador] = useState(null);
    const [personas, setPersonas] = useState([]);
    const [idFormulario, setIdFormulario] = useState("");
    const [idEvaluado, setIdEvaluado] = useState("");
    const [respuestas, setRespuestas] = useState({});
    const [guardando, setGuardando] = useState(false);

    const [modal, setModal] = useState({
        visible: false,
        tipo: "info",
        titulo: "",
        mensaje: "",
    });

    const mostrarModal = (tipo, titulo, mensaje) => {
        setModal({ visible: true, tipo, titulo, mensaje });
    };

    const cerrarModal = () => {
        setModal({ ...modal, visible: false });
    };

    useEffect(() => {
        const cargarDatos = async () => {
            cargarEvaluador();
            await Promise.all([cargarFormularios(), getPersonsCV(), getContactInfo()]);
        };
        cargarDatos();
    }, []);

    const cargarFormularios = async () => {
        try {
            const f = await ObtenerFormularios();
            const activos = (f || []).filter((form) => form.Activo || form.activo);
            setFormularios(activos);
        } catch (err) {
            console.error("❌ Error cargando formularios:", err);
        }
    };

    const cargarEvaluador = () => {
        try {
            const jsonUsuario = sessionStorage.getItem("USER_DATA");
            if (!jsonUsuario) return;

            const usuario = JSON.parse(jsonUsuario);
            setEvaluador({
                IdPersona: usuario.IdUsuario || usuario.idUsuario || usuario.id || null,
                NombreUsuario:
                    usuario.NombreUsuario ||
                    usuario.NombreCompleto ||
                    usuario.nombreCompleto ||
                    usuario.nombre ||
                    "Usuario desconocido",
                Correo: usuario.Correo || "",
                TipoUsuario: usuario.TipoUsuario || "",
            });
        } catch (err) {
            console.error("❌ Error al cargar evaluador:", err);
        }
    };

    async function getPersonsCV() {
        try {
            const response = await ObtenerPersonasCV();
            const normalizadas = (response || [])
                .filter(p => p.TrabajaEnRossmon === 1 || p.trabajaEnRossmon === 1)
                .map((p) => ({
                    idPersona: p.idPerson ?? p.IdPersona,
                    nombre: p.nombre ?? p.NombreCompleto ?? p.Nombre ?? "Sin nombre",
                    especializacion: p.nombreEspecializacion ?? p.NombreEspecializacion ?? "",
                }));
            setPersonas(normalizadas);
        } catch (error) {
            console.error("❌ Error al obtener personas:", error);
            setPersonas([]);
        }
    }

    async function getContactInfo() {
        try {
            await ObtenerInfoContacto();
        } catch (error) {
            console.error("❌ Error al obtener contacto:", error);
        }
    }

    const cargarPreguntas = async (idForm) => {
        setPreguntas([]);
        setRespuestas({});
        if (!idForm) return;

        try {
            const p = await ObtenerPreguntasPorFormulario(idForm);
            if (!Array.isArray(p) || p.length === 0) {
                mostrarModal(
                    "info",
                    "Formulario vacío",
                    "El formulario seleccionado no contiene preguntas registradas."
                );
                return;
            }

            setPreguntas(
                p.map((x, i) => ({
                    IdPregunta: x.IdPregunta ?? x.idPregunta,
                    Texto: x.Texto ?? x.texto,
                    Tipo: (x.Tipo ?? x.tipo ?? "abierta").toLowerCase(),
                    EscalaMin: x.EscalaMin ?? 1,
                    EscalaMax: x.EscalaMax ?? 5,
                    Orden: x.Orden ?? i + 1,
                    Requerida: x.Requerida ?? x.requerida ?? false,
                }))
            );
        } catch (err) {
            console.error("❌ Error cargando preguntas:", err);
        }
    };

    const handleChangeRespuesta = (idPregunta, valor) => {
        setRespuestas((prev) => ({ ...prev, [idPregunta]: valor }));
    };

    const guardarEvaluacion = async () => {
        if (!idFormulario)
            return mostrarModal("error", "Error", "Seleccione un formulario.");
        if (!evaluador?.IdPersona)
            return mostrarModal("error", "Error", "No se encontró el evaluador actual.");
        if (!idEvaluado)
            return mostrarModal("error", "Error", "Seleccione a quién desea evaluar.");
        if (preguntas.length === 0)
            return mostrarModal("error", "Error", "El formulario no tiene preguntas.");

        const faltantes = preguntas
            .filter((p) => p.Requerida && !respuestas[p.IdPregunta])
            .map((p) => p.Texto);

        if (faltantes.length > 0) {
            console.warn("❌ Preguntas sin responder:", faltantes);
            return mostrarModal(
                "error",
                "Faltan respuestas",
                "Debe responder todas las preguntas requeridas antes de guardar"
            );
        }

        setGuardando(true);

        try {
            const payloadEval = {
                IdFormulario: parseInt(idFormulario, 10),
                IdEvaluador: parseInt(evaluador.IdPersona, 10),
                IdEvaluado: parseInt(idEvaluado, 10),
            };

            const evalData = await CrearEvaluacion(payloadEval);
            if (!evalData || evalData.indicador !== 0) {
                setGuardando(false);
                return mostrarModal(
                    "error",
                    "Error",
                    evalData?.mensaje || "No se pudo crear la evaluación."
                );
            }

            const match = evalData.mensaje?.match(/ID=(\d+)/);
            const idEvalGenerado = match ? parseInt(match[1]) : null;
            if (!idEvalGenerado) {
                setGuardando(false);
                return mostrarModal(
                    "error",
                    "Error",
                    "No se pudo obtener el ID de la evaluación creada."
                );
            }

            for (const p of preguntas) {
                const respuesta = String(respuestas[p.IdPregunta] ?? "");
                if (!respuesta) continue;

                const payloadResp = {
                    IdEvaluacion: parseInt(idEvalGenerado, 10),
                    IdPregunta: parseInt(p.IdPregunta, 10),
                    Respuesta: String(respuesta),
                };

                try {
                    await GuardarRespuesta(payloadResp);
                } catch (err) {
                  
                }
            }

            mostrarModal(
                "success",
                "¡Éxito!",
                "Evaluación y respuestas guardadas correctamente."
            );
            setIdFormulario("");
            setPreguntas([]);
            setRespuestas({});
            setIdEvaluado("");
        } catch (err) {
           
            mostrarModal("error", "Error", "Ocurrió un error al guardar la evaluación.");
        } finally {
            setGuardando(false);
        }
    };

    return (
        <div className="flex flex-row min-h-screen bg-[#f8f9fb]">
            <div className="md:basis-1/4 xl:basis-1/5">
                <SideBar />
            </div>

            <div className="md:basis-3/4 xl:basis-11/12 p-8">
                <div className="bg-white rounded-3xl shadow-md px-10 py-10 border border-gray-100">
                    <h1 className="text-2xl font-bold text-gray-800 mb-1">Nueva evaluación</h1>
                    <p className="text-sm text-gray-500 mb-8">
                        Complete la evaluación seleccionando el formulario y la persona evaluada.
                    </p>

                    
                    <div className="grid grid-cols-2 gap-6 mb-8">
                        <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-2 uppercase tracking-wide">
                                Persona evaluada
                            </label>
                            <Select
                                options={personas.map(p => ({ value: p.idPersona, label: p.nombre }))}
                                placeholder="Seleccione..."
                                value={personas.map(p => ({ value: p.idPersona, label: p.nombre }))
                                    .find(opt => opt.value === idEvaluado) || null}
                                onChange={(opt) => setIdEvaluado(opt?.value || "")}
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        borderRadius: "12px",
                                        borderColor: "#d1d5db",
                                        boxShadow: "none",
                                        ":hover": { borderColor: "#10b981" }
                                    })
                                }}
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-2 uppercase tracking-wide">
                                Formulario
                            </label>
                            <Select
                                options={formularios.map(f => ({ value: f.idFormulario, label: f.nombre }))}
                                placeholder="Seleccione..."
                                value={formularios.map(f => ({ value: f.idFormulario, label: f.nombre }))
                                    .find(opt => opt.value === idFormulario) || null}
                                onChange={(opt) => {
                                    setIdFormulario(opt?.value || "");
                                    cargarPreguntas(opt?.value || "");
                                }}
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        borderRadius: "12px",
                                        borderColor: "#d1d5db",
                                        boxShadow: "none",
                                        ":hover": { borderColor: "#10b981" }
                                    })
                                }}
                            />
                        </div>
                    </div>

                    
                    {preguntas.length > 0 && (
                        <div className="space-y-6">
                            {preguntas.map((p, index) => (
                                <div
                                    key={p.IdPregunta}
                                    className="p-6 border border-gray-200 bg-white rounded-2xl shadow-sm hover:shadow-md transition relative"
                                >
                                    <div className="flex justify-between items-center mb-4">
                                        <h4 className="text-base font-semibold text-gray-800">
                                            {index + 1}. {p.Texto}
                                        </h4>
                                        <span className={`text-xs font-medium px-3 py-1 rounded-full 
                                            ${p.Requerida ? "bg-red-50 border border-red-200 text-red-600" : "bg-blue-50 border border-blue-100 text-blue-500"}`}>
                                            {p.Requerida ? "Requerida" : p.Tipo.charAt(0).toUpperCase() + p.Tipo.slice(1)}
                                        </span>
                                    </div>

                                    {p.Tipo === "abierta" && (
                                        <textarea
                                            className="w-full border border-gray-300 rounded-xl p-3 bg-gray-50 text-gray-700 focus:ring-2 focus:ring-emerald-400 focus:outline-none transition placeholder-gray-400"
                                            rows="3"
                                            placeholder="Escribe tu respuesta..."
                                            value={respuestas[p.IdPregunta] || ""}
                                            onChange={(e) =>
                                                handleChangeRespuesta(p.IdPregunta, e.target.value)
                                            }
                                        />
                                    )}

                                    {p.Tipo === "sino" && (
                                        <div className="flex gap-6 mt-2">
                                            {["Sí", "No"].map((valor) => (
                                                <label
                                                    key={valor}
                                                    className={`flex items-center gap-2 px-3 py-2 rounded-lg cursor-pointer border transition ${respuestas[p.IdPregunta] === valor
                                                        ? "bg-emerald-100 border-emerald-400 text-emerald-700"
                                                        : "border-gray-300 hover:border-emerald-300"
                                                        }`}
                                                >
                                                    <input
                                                        type="radio"
                                                        name={`radio-${p.IdPregunta}`}
                                                        value={valor}
                                                        checked={respuestas[p.IdPregunta] === valor}
                                                        onChange={(e) =>
                                                            handleChangeRespuesta(
                                                                p.IdPregunta,
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                    {valor}
                                                </label>
                                            ))}
                                        </div>
                                    )}

                                    {p.Tipo === "likert" && (
                                        <div className="flex justify-start gap-3 mt-3">
                                            {Array.from(
                                                { length: p.EscalaMax - p.EscalaMin + 1 },
                                                (_, i) => p.EscalaMin + i
                                            ).map((valor) => (
                                                <button
                                                    key={valor}
                                                    type="button"
                                                    onClick={() =>
                                                        handleChangeRespuesta(
                                                            p.IdPregunta,
                                                            String(valor)
                                                        )
                                                    }
                                                    className={`w-11 h-11 rounded-full border text-sm font-semibold transition ${respuestas[p.IdPregunta] == valor
                                                        ? "bg-emerald-600 text-white border-emerald-600 shadow-md scale-110"
                                                        : "bg-gray-50 text-gray-700 border-gray-300 hover:bg-emerald-50"
                                                        }`}
                                                >
                                                    {valor}
                                                </button>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}

                    
                    <div className="flex justify-end mt-10 gap-4">
                        <button
                            onClick={guardarEvaluacion}
                            disabled={guardando}
                            className="px-6 py-3 bg-emerald-600 text-white font-semibold rounded-xl hover:bg-emerald-700 transition shadow-md disabled:opacity-50"
                        >
                            {guardando ? "Guardando..." : "Guardar evaluación"}
                        </button>

                        <button
                            onClick={() => {
                                setIdFormulario("");
                                setPreguntas([]);
                                setRespuestas({});
                                setIdEvaluado("");
                            }}
                            className="px-6 py-3 bg-gray-200 text-gray-700 font-semibold rounded-xl hover:bg-gray-300 transition shadow-sm"
                        >
                            Limpiar
                        </button>
                    </div>
                </div>
            </div>

            
            {modal.visible && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50"
                    onClick={cerrarModal}
                >
                    <div
                        className={`bg-white rounded-2xl shadow-lg p-8 w-96 text-center relative ${modal.tipo === "success"
                            ? "border-l-8 border-emerald-600"
                            : "border-l-8 border-red-500"
                            }`}
                        onClick={(e) => e.stopPropagation()}
                    >
                        {/* Ícono */}
                        <div className="flex justify-center mb-4">
                            {modal.tipo === "success" ? (
                                <svg
                                    className="w-14 h-14 text-emerald-600"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    viewBox="0 0 24 24"
                                >
                                    <circle cx="12" cy="12" r="10" className="stroke-emerald-600" />
                                    <path
                                        className="stroke-emerald-600"
                                        d="M8 12l2.5 2.5L16 9"
                                    />
                                </svg>
                            ) : (
                                <svg
                                    className="w-14 h-14 text-red-600"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    viewBox="0 0 24 24"
                                >
                                    <circle cx="12" cy="12" r="10" className="stroke-red-600" />
                                    <path
                                        className="stroke-red-600"
                                        d="M15 9l-6 6M9 9l6 6"
                                    />
                                </svg>
                            )}
                        </div>

                        
                        <h2
                            className={`text-xl font-bold mb-2 ${modal.tipo === "success"
                                ? "text-emerald-700"
                                : "text-red-600"
                                }`}
                        >
                            {modal.titulo}
                        </h2>

                        {/* Mensaje */}
                        <p className="text-gray-700 mb-6 whitespace-pre-line">{modal.mensaje}</p>

                        {/* Botón */}
                        <button
                            onClick={cerrarModal}
                            className={`px-6 py-2 rounded-lg text-white font-semibold transition ${modal.tipo === "success"
                                ? "bg-emerald-600 hover:bg-emerald-700"
                                : "bg-red-500 hover:bg-red-600"
                                }`}
                        >
                            Cerrar
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}
